import { Tabs } from "antd";
import React from "react";
import Order from "./components/Order";
import BestsellingProducts from "./components/BestsellingProducts";
import AllProducts from "./components/AllProducts";
import CardHeader from "../../components/atoms/cardHeader";
import StockAvailability from "./components/StockAvailability";
import CardWrapper from "../../components/molecules/CardWrapper";

const ReportsAnalytics = () => {
  const tabItems = [
    {
      key: "1",
      label: "Order",
      children: <Order />,
    },
    {
      key: "2",
      label: "Bestselling Products",
      children: <BestsellingProducts />,
    },
    {
      key: "3",
      label: "Stock Availability",
      children: <StockAvailability />,
    },
    {
      key: "4",
      label: "All Products",
      children: <AllProducts />,
    },
  ];
  return (
    <>
      <div className="content d-flex flex-column flex-column-fluid">
        <CardWrapper>
          <CardHeader name="Reports & Analytics" tooltipText={"View order data, best-selling products, stock availability, and complete product insights in one place."} />
          <div className="card-body p-4">
            <Tabs defaultActiveKey="1" items={tabItems} />
          </div>
        </CardWrapper>
      </div>
    </>
  );
};

export default ReportsAnalytics;
